import React from 'react';
import axios from './../../../../constants/axios';

class ProductMainHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         product: {}
      };
   }

   componentDidMount() {
      const productId = this.props.params.productId;
      axios.get(`items/products/main/${productId}`)
         .then((res) => {
            this.setState({
               product: res.data
            });
         });
   }

   render() {
      const { product } = this.state;
      return (
         <div>
            <h4>General Information</h4>
            <div>
               <p>Name: {product.name}</p>
               <p>Description: {product.description}</p>
               <p>Price: {product.price}</p>
               <p>Discount: {product.discount}</p>
               <p>Net Weight: {product.net_weight}</p>

               {product.subProducts ?
                  <div>
                     <hr/>
                     <h4>Sub Products</h4>
                     {product.subProducts.map((sP) => (
                        <div key={sP.id} >
                           <p>Name: {sP.sub_item_variant}</p>
                        </div>
                     ))}
                  </div>
                  : ''
               }

               <hr/>
               <h4>Main Image</h4>


               <hr/>
               <h4>Images</h4>

               <hr/>
               <h4>Locations</h4>

               <hr/>
               <h4>Features</h4>

            </div>
         </div>
      );
   }
}

ProductMainHome.propTypes = {
   params: React.PropTypes.object
};

export default ProductMainHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainHome.js
 **/